import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { MeepCardModel } from '../models/meepCard.model';
import Auth from '../helpers/auth';

@Injectable()
export class MeepCardService extends AppService<MeepCardModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async get() {
    const result = await this.getAllAsync(`MeepCard/Responsible/${Auth.getUser().id}`);
    return result;
  }

  async updateDeactiveCard(meepCard, EhNominal) {
    let result;
    if (EhNominal) {
      result = await this.putAsync(`CartaoCashlessNominal/Status`, meepCard);
    } else {
      result = await this.putAsync(`CartaoCashlessRotativo/Status`, meepCard);
    }
    return result;
  }

  async changePassword(password: string, meepCardNumber: string) {
    const result = await this.putAsync(`CartaoCashlessNominal/Senha`, { Tag: meepCardNumber, Senha: password});
    return result;
  }

  async changeCardName(cardname: string, meepCardNumber: string) {
    const result = await this.putAsync(`CartaoCashlessNominal/Apelido`, { Tag: meepCardNumber, Apelido: cardname});
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/meepCard.service.ts